import React from "react";

import { BetOffer } from "@models";
import NormalEventData from "../bet-slip-shared-page/body/item/offer/NormalEventData";
import EventData from "../bet-slip-shared-page/body/item/offer/EventData";

export default function EventDataWrapper(props: { offer: BetOffer }) {
	if (props.offer.sportData.eventType != 0) {
		return <NormalEventData offer={props.offer} />;
	}

	return <EventData offer={props.offer} />;
}
